// Product-authored Work and Bots guides ship with the app. This small catalog is shared
// by the client, API, SSR, sitemap and seed importer so releases stay aligned.
const { pages } = require('./workGuides.json');
const { pages: botPages } = require('./botGuides.json');
const releasedPages = [...pages, ...botPages];
const index = new Map(releasedPages.map(page => [`${page.guideType}:${page.slug}`, page]));
function getWorkGuide(type, slug) {
  return index.get(`${type}:${slug}`) || null;
}
function mergeWorkPages(existing = [], type) {
  const shipped = releasedPages.filter(page => !type || page.guideType === type);
  const keys = new Set(shipped.map(page => `${page.guideType}:${page.slug}`));
  const prior = new Map(existing.map(page => [`${page.guideType}:${page.slug}`, page]));
  const released = shipped.map(page => {
    const ogImage = prior.get(`${page.guideType}:${page.slug}`)?.meta?.ogImage;
    return ogImage && !page.meta.ogImage ? { ...page, meta: { ...page.meta, ogImage } } : page;
  });
  return [...existing.filter(page => !keys.has(`${page.guideType}:${page.slug}`)), ...released];
}
function mergeWorkNavigation(sections = [], type) {
  const shipped = pages.filter(page => page.guideType === type);
  const slugs = new Set(shipped.map(page => page.slug));
  const result = sections.map(section => ({ ...section, items: (section.items || []).filter(item => !slugs.has(item.slug)) })).filter(section => section.items.length);
  const groups = type === 'learn'
    ? [['module-7-agentic-workflows', 'Module 7: Your Work'], ['module-8-work-projects', 'Module 8: Work Projects']]
    : [['work-agent', 'Work']];
  for (const [slug, title] of groups) {
    const group = { slug, title, items: shipped.filter(page => page.navSectionSlug === slug).sort((a, b) => a.navOrder - b.navOrder).map(page => ({ slug: page.slug, label: page.title, icon: page.navIcon, description: page.description, href: page.canonicalPath, keywords: page.searchKeywords })) };
    const prior = sections.findIndex(section => section.slug === slug || section.title === title);
    const extraIndex = result.findIndex(section => section.slug === slug || section.title === title);
    if (extraIndex >= 0) group.items.push(...result.splice(extraIndex, 1)[0].items);
    // Work docs follow Getting Started; workshops follow the foundations.
    const position = type === 'docs' ? (prior >= 0 ? Math.min(prior, result.length) : Math.min(1, result.length)) : result.length;
    result.splice(position, 0, group);
  }
  if (type === 'docs') {
    const titles = { 'getting-started': 'Getting Started', 'core-concepts': 'Core Concepts', features: 'Features', developer: 'Developer' };
    const updates = new Map(botPages.map(page => [page.slug, page]));
    const toItem = page => ({ slug: page.slug, label: page.title, icon: page.navIcon, description: page.description, href: page.canonicalPath, keywords: page.searchKeywords });
    for (const section of result) {
      section.items = section.items.map(item => {
        const page = updates.get(item.slug);
        if (!page) return item;
        updates.delete(item.slug);
        return { ...item, ...toItem(page) };
      });
    }
    for (const page of [...updates.values()].sort((a, b) => a.navOrder - b.navOrder)) {
      const title = titles[page.navSectionSlug];
      let section = result.find(item => item.slug === page.navSectionSlug || item.title === title);
      if (!section) {
        section = { slug: page.navSectionSlug, title, items: [] };
        if (page.navSectionSlug === 'getting-started') result.unshift(section);
        else result.push(section);
      }
      section.items.push(toItem(page));
    }
  }
  return result;
}
module.exports = { getWorkGuide, mergeWorkPages, mergeWorkNavigation };
